import { FeatureFlag } from '../FeatureFlag';
import { z } from 'zod';

const DEFAULT_MESSAGES_STORE_RETENTION_LIMIT = 10_000;

export const MessagesStoreRetentionLimitSchema = z.coerce
    .number()
    .finite()
    .transform((value) => Math.max(1, Math.trunc(value)));

export const messagesStoreRetentionLimit = new FeatureFlag<number>({
    key: 'messages-store-retention-limit',
    createdOn: '2026-06-24',
    defaultValue: DEFAULT_MESSAGES_STORE_RETENTION_LIMIT,
    parseValue: (value: unknown) => MessagesStoreRetentionLimitSchema.parse(value),
});
